import { render } from "./KeyResultBody.vue?vue&type=template&id=ff7d5538&scoped=true"
import script from "./KeyResultBody.vue?vue&type=script&lang=js"
export * from "./KeyResultBody.vue?vue&type=script&lang=js"

import "./KeyResultBody.vue?vue&type=style&index=0&id=ff7d5538&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ff7d5538"

export default script